// src/pages/products/components/DropshippingSection.jsx
import React from 'react';
import { useLocalization } from '../../../contexts/LocalizationContext';
import styles from './DropshippingSection.module.css';

/**
 * Dropshipping tab content for Create/Edit Product pages.
 * Shown only when the business has isProviderEnabled = true.
 *
 * Props:
 *   dropshippingEnabled       boolean
 *   minimumSellingPrice       string | number
 *   maximumSellingPrice       string | number
 *   onChange(field, value)    handler
 */
const DropshippingSection = ({
  dropshippingEnabled,
  minimumSellingPrice,
  maximumSellingPrice,
  dropshippingPrice,
  onChange,
}) => {
  const { t } = useLocalization();

  return (
    <div className={styles.section}>
      <div className={styles.toggleRow}>
        <div>
          <div className={styles.fieldLabel}>{t('dropshipping.enableProvider')}</div>
          <div className={styles.fieldHelp}>{t('dropshipping.enableProviderHelp')}</div>
        </div>
        <label className={styles.toggle}>
          <input
            type="checkbox"
            checked={!!dropshippingEnabled}
            onChange={(e) => onChange('dropshippingEnabled', e.target.checked)}
          />
          <span className={styles.toggleSlider} />
        </label>
      </div>

      <div className={styles.priceFields}>
        <div className={styles.fieldGroup}>
          <label className={styles.fieldLabel}>
            {t('dropshipping.dropshippingPrice')}
            {dropshippingEnabled && <span className={styles.required}> *</span>}
          </label>
          <input
            type="number"
            min="0"
            step="0.01"
            className={styles.input}
            value={dropshippingPrice || ''}
            onChange={(e) => onChange('dropshippingPrice', e.target.value)}
          />
        </div>
        <div className={styles.fieldGroup}>
          <label className={styles.fieldLabel}>
            {t('dropshipping.minSellingPrice')}
            {dropshippingEnabled && <span className={styles.required}> *</span>}
          </label>
          <input
            type="number"
            min="0"
            step="0.01"
            className={styles.input}
            value={minimumSellingPrice || ''}
            onChange={(e) => onChange('minimumSellingPrice', e.target.value)}
          />
        </div>
        <div className={styles.fieldGroup}>
          <label className={styles.fieldLabel}>
            {t('dropshipping.maxSellingPrice')}
            {dropshippingEnabled && <span className={styles.required}> *</span>}
          </label>
          <input
            type="number"
            min="0"
            step="0.01"
            className={styles.input}
            value={maximumSellingPrice || ''}
            onChange={(e) => onChange('maximumSellingPrice', e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default DropshippingSection;
